module.exports = __webpack_public_path__ + "static/img/icons-03.3d3c280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons-03.png
// module id = 1412
// module chunks = 4